import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";

@Component({
    selector: 'app-badge-status',
    templateUrl: './badge-status.component.html',
    standalone: true,
    imports: [CommonModule]
})
export class BadgeStatusComponent {
    @Input() statusLabel?: string;
}